import React from 'react';
//import hrefs from './hrefs'

const newline = '\n';

function lineToBr(text, skip) {
  
    if (typeof text === 'number') {
        return text;
    } else if (typeof text !== 'string') {
        return '';
    }

    let lines = text.split(newline);
    return lines.map(function(line, i) {
        return (
            <span key={i}>
                {line}
                <br/>
            </span>
        );
    });
}

module.exports = lineToBr;